import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    minWidth: '700px',
    maxWidth: '800px',
    borderRadius: '8px',
  },
  dialogTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '16px 24px 8px 24px',
    borderBottom: '1px solid #e0e0e0',
  },
  titleText: {
    fontSize: '18px',
    fontWeight: 'bold',
    color: '#312e34',
  },
  headerActions: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    padding: '24px 24px 16px 24px',
    gap: '24px',
  },
  selectorsRow: {
    display: 'flex',
    gap: '24px',
    width: '100%',
  },
  selectorField: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    gap: '6px',
  },
  selectorLabel: {
    fontSize: '13px',
    color: '#828282',
  },
  selectField: {
    width: '100%',
    '& .MuiOutlinedInput-input': {
      padding: '10px 14px',
    },
  },
  centerPlaceholder: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '40px 16px',
    minHeight: '220px',
  },
  discoveringContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '40px 16px',
    gap: '24px',
    width: '100%',
  },
  discoveringHeaderRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    marginBottom: '16px',
  },
  warningBox: {
    display: 'flex',
    gap: '10px',
    alignItems: 'flex-start',
    backgroundColor: '#FEF7E7',
    border: '1px solid #F7E0A9',
    borderRadius: '4px',
    padding: '12px 16px',
    maxWidth: '480px',
    textAlign: 'left',
  },
  warningIcon: {
    flexShrink: 0,
    marginTop: '1px',
  },
  warningText: {
    fontSize: '13.5px',
    lineHeight: '1.45',
    color: '#4F4F4F',
  },
  tableContainer: {
    maxHeight: '300px',
    overflowY: 'auto',
    border: '1px solid #e0e0e0',
    borderRadius: '4px',
  },
  errorText: {
    color: '#d32f2f',
    fontSize: '14px',
    marginTop: '8px',
  },
  headerCellWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    cursor: 'pointer',
    userSelect: 'none',
  },
  deviceNameBold: {
    fontWeight: 'bold',
  },
  headerRowSpacer: {
    flex: 1,
  },
  headerRowAction: {
    flex: 1,
    display: 'flex',
    justifyContent: 'flex-end',
  },
  addDialog: {
    maxWidth: '80vw',
    width: 'max-content',
    borderRadius: '8px',
    '& .base-dialog-paper': {
      width: 'max-content',
      maxWidth: '80vw',
      borderRadius: '8px',
    },
    '& .confirm-button':{
      minWidth: '142px !important',
    },
  },
  customCheckbox16: {
    width: '21px !important',
    height: '21px !important',
    padding: '0px !important',
    transform: 'translate(0, 3px)',
    '& svg': {
      width: '21px !important',
      height: '21px !important',
      fontSize: '21px !important',
    },
  },
  noResultsContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '32px 24px',
    width: '100%',
    minHeight: '120px',
  },
}));

export default useStyles;


